import { useCallback } from 'react';
import { useAppDispatch } from './hooks';
import { setAuthError } from '../slices/appSlice';
import { YANDEX_OAUTH_STATE_KEY } from '../constants/yandexAuth';

const YANDEX_AUTH_URL = 'https://oauth.yandex.ru/authorize';
declare const __YANDEX_CLIENT_ID__: string;
declare const __YANDEX_REDIRECT_URI__: string;

export const useYandexAuth = () => {
	const dispatch = useAppDispatch();

	const handleYandexLogin = useCallback(() => {
		dispatch(setAuthError(false));
		const state = crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`;
		window.sessionStorage.setItem(YANDEX_OAUTH_STATE_KEY, state);
		const redirectUri = __YANDEX_REDIRECT_URI__ || `${window.location.origin}/callback_auth/yandex`;
		const clientId = __YANDEX_CLIENT_ID__;
		if (!clientId) {
			window.location.href = `${redirectUri}?dev=true&code=code`;
			return;
		}
		const params = new URLSearchParams({
			client_id: clientId,
			response_type: 'code',
			redirect_uri: redirectUri,
			state,
		});
		window.location.assign(`${YANDEX_AUTH_URL}?${params.toString()}`);
	}, [dispatch]);

	return {
		handleYandexLogin,
	};
};
